import { combineReducers } from 'redux';
import { SET_PROJECT_SOFTWARE, SET_PROJECTS_LIST, SET_PROJECTS_LIST_SKIP } from './actions';
import singleReducer from '../scenes/singleProject/data/reducer';

/**
 * Structured like this so when combining reducers, you can have state.projects.list.
 * If the initial state was a traditional object containing a listing property, an additional depth level would have been required, example state.projects.shared.list.
 * When combining reducers, you cannot spread a reducer, it needs a key.
 * @param state
 * @param action
 * @returns {*}
 */
const listingReducer = (state = { data: [], skip: 0, total: 0 }, action) => {
  switch (action.type) {
    case SET_PROJECTS_LIST:
      return { ...state, data: action.data, total: action.total };
    case SET_PROJECTS_LIST_SKIP:
      return { ...state, skip: action.skip };
    default:
      return state;
  }
};

const softwareReducer = (state = [], action) => {
  switch (action.type) {
    case SET_PROJECT_SOFTWARE:
      return action.software;
    default:
      return state;
  }
};

const projectsReducer = combineReducers({
  list: listingReducer,
  single: singleReducer,
  software: softwareReducer
});

export default projectsReducer;



// WEBPACK FOOTER //
// ./src/scenes/projects/data/reducer.js